export const FILTER_ROW_ITEM_GAP = 2.5;

export const FILTER_ROW_LABEL_GAP = 0.5;

// Trigger → dropdown-window gap mirrors the row chrome's own padding (spacing units).
export const FILTER_DROPDOWN_GAP = 1;

export const FILTER_ROW_CHROME = Object.freeze({
  panelCompact: {
    paperVariant: "filterPanelCompact",
    dropdownGap: 1,
    layout: { alignItems: { xs: "stretch", md: "flex-end" } },
  },
  panelComfortable: {
    paperVariant: "filterPanelComfortable",
    dropdownGap: 2,
    layout: { alignItems: { xs: "stretch", md: "center" } },
  },
  bare: {
    paperVariant: null,
    dropdownGap: FILTER_DROPDOWN_GAP,
    layout: {
      p: 0,
      backgroundColor: "transparent",
      border: "none",
      alignItems: { xs: "stretch", md: "flex-end" },
    },
  },
});

export const getFilterRowChrome = () => FILTER_ROW_CHROME;

export const FILTER_ROW_ITEM_SX = { minWidth: 0, flex: { md: "1 1 220px" } };

// A date range holds two date inputs, so its cell claims twice a dropdown's share.
export const FILTER_ROW_DATE_RANGE_ITEM_SX = { flex: { md: "2 1 400px" } };

// Fits a dd-MM-yyyy value plus the input's side padding and calendar adornment.
export const FILTER_DATE_INPUT_SX = { flex: "1 1 0", minWidth: (theme) => `calc(10ch + ${theme.spacing(10)})` };

export const FILTER_ROW_LABEL_SX = {
  display: "block",
  color: "text.textGrey",
  mb: FILTER_ROW_LABEL_GAP,
};
